var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlackIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.925293,
    width: 49,
    height: 49,
    rx: 24.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.925293,
    width: 49,
    height: 49,
    rx: 24.5,
    stroke: "#ECECF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9787 31.2384C15.685 31.2364 16.3619 30.9452 16.8612 30.4283C17.3605 29.9114 17.6416 29.211 17.6431 28.4803V25.724H14.9787C14.2726 25.7255 13.5959 26.0161 13.0963 26.5322C12.5967 27.0483 12.3149 27.748 12.3125 28.4784C12.3143 29.999 13.5069 31.2328 14.9769 31.2347L14.9787 31.2384ZM21.6523 25.7222C20.946 25.7241 20.2691 26.0154 19.7698 26.5323C19.2705 27.0492 18.9894 27.7496 18.9879 28.4803V35.3859C18.9916 36.9065 20.1842 38.1384 21.6523 38.1422C22.3584 38.1402 23.0349 37.8492 23.5342 37.3327C24.0334 36.8162 24.3148 36.1163 24.3167 35.3859V28.4784C24.3148 27.748 24.0334 27.0481 23.5342 26.5316C23.0349 26.0152 22.3584 25.7241 21.6523 25.7222Z",
    fill: "#E01E5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9879 15.0584C18.9898 16.579 20.1824 17.8128 21.6523 17.8147H24.3167V15.0584C24.3153 14.328 24.0344 13.6279 23.5355 13.1111C23.0366 12.5943 22.3602 12.3028 21.6541 12.3003C20.9481 12.3023 20.2715 12.5933 19.7722 13.1098C19.273 13.6262 18.9917 14.3261 18.9897 15.0565L18.9879 15.0584ZM24.3167 21.9622C24.3148 21.2318 24.0334 20.5319 23.5342 20.0154C23.0349 19.4989 22.3584 19.2079 21.6523 19.2059H14.9769C14.2708 19.2079 13.5942 19.4989 13.095 20.0154C12.5957 20.5319 12.3144 21.2318 12.3125 21.9622C12.3161 23.4847 13.5088 24.7165 14.9769 24.7184H21.6541C22.3602 24.7164 23.0368 24.4254 23.536 23.9089C24.0353 23.3925 24.3148 22.6926 24.3167 21.9622Z",
    fill: "#36C5F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3481 24.7203C29.0542 24.7183 29.7307 24.4273 30.23 23.9108C30.7292 23.3944 31.0106 22.6944 31.0125 21.964V15.0565C31.0106 14.3265 30.7295 13.6268 30.2306 13.1104C29.7318 12.594 29.0557 12.3028 28.3499 12.3003C27.6439 12.3023 26.9673 12.5933 26.468 13.1098C25.9688 13.6262 25.6875 14.3261 25.6855 15.0565V21.964C25.6892 23.4828 26.8782 24.7165 28.3481 24.7203ZM35.0217 19.2059C34.3157 19.2079 33.6391 19.4989 33.1398 20.0154C32.6406 20.5319 32.3593 21.2318 32.3574 21.9622V24.7184H35.0217C35.7278 24.7169 36.4046 24.4264 36.9041 23.9103C37.4037 23.3942 37.6855 22.6944 37.6879 21.964C37.686 21.2336 37.4047 20.5337 36.9054 20.0173C36.4062 19.5008 35.7296 19.2098 35.0235 19.2078L35.0217 19.2059Z",
    fill: "#2EB67D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6836 28.4844C25.6872 30.005 26.878 31.2387 28.348 31.2406H35.0234C35.7291 31.2386 36.4055 30.9479 36.9047 30.4318C37.4039 29.9157 37.6854 29.2163 37.6878 28.4862C37.6859 27.7558 37.4045 27.0559 36.9053 26.5395C36.406 26.023 35.7295 25.732 35.0234 25.73H28.348C27.6419 25.732 26.9653 26.023 26.4661 26.5395C25.9668 27.0559 25.6855 27.754 25.6836 28.4844ZM31.0123 35.3881C31.0104 34.6577 30.7291 33.9578 30.2299 33.4413C29.7306 32.9249 29.054 32.6338 28.348 32.6319H25.6836V35.3881C25.6872 36.9106 26.878 38.1425 28.348 38.1444C29.054 38.1424 29.7306 37.8513 30.2299 37.3349C30.7291 36.8184 31.0104 36.1185 31.0123 35.3881Z",
    fill: "#ECB22E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlackIcon);
export default __webpack_public_path__ + "static/media/slackIcon.3b8967f4f63f019e188f6cfc1069c37f.svg";
export { ForwardRef as ReactComponent };